/* global App */

<template>
    <div id="map-wrapper">
      <search :place="place"></search>
      <mapAndDetails></mapAndDetails>
    </div>
</template>

<script>

import search from './search.vue'
import mapAndDetails from './mapAndDetails.vue'

export default {
  data: function () {
    return {
        showDetails: false,
        mapCreated: false,
    }
  },
  props: ['place'],
  mounted: function () {
    var vm = this
    // App not yet defined, we need to wait before emitting event (direct hit)
    if (window.App === undefined) {
      eventBus.$on('rootReady',() => {
        eventBus.$emit('slugPageEvent', vm.$route.params.slug)
        vm.setupMap()
      })
    // App ready so we can emit event (pass by router)
    } else {
      eventBus.$emit('slugPageEvent', vm.$route.params.slug)
      vm.setupMap()
    }
  },
  methods: {
    setupMap: function() {
      if (window.mapCreated === undefined) {
        var mapScript
        mapScript = document.createElement('SCRIPT')
        mapScript.setAttribute('src', "https://maps.googleapis.com/maps/api/js?key=AIzaSyAsqo-CRjCxfkqjKPG_3X9MEAlFU2iuJMM&libraries=places&callback=App.mapCallback")
        mapScript.setAttribute('async', '')
        mapScript.setAttribute('defer', '')
        document.body.appendChild(mapScript)
        window.mapCreated = true
      } else {
        eventBus.$emit('redoMapEvent')
      }
    }
  },
  components: {
    'search': search,
    'mapAndDetails': mapAndDetails,
  },
}

</script>
